import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { AppConfig, AppLoaderState, AppState, iSnackBar, UIError } from 'common/interfaces';
import { IUserProfile } from 'common/interfaces/iprofile';
import { isEqual, merge } from 'lodash';

const initialAppState = {
  isUserLoggedIn: false,
  loggedInUser: {} as IUserProfile,
} as AppState;

const snackBarInitialState = {
  visible: false,
  message: '',
  type: 1,
  delay: 2000,
  iconType: undefined,
  autoClose: false,
  disableClose: false,
  showTime: 2000,
} as iSnackBar;

const reducers = {
  setLoading: (state: AppState, action: PayloadAction<boolean>) => {
    state.loading = action.payload;
  },
  setError: (state: AppState, action: PayloadAction<UIError>) => {
    state.error = action.payload;
  },
  setIsUserLoggedIn: (state: AppState, action: PayloadAction<boolean>) => {
    state.isUserLoggedIn = action.payload;
  },
  setIsAppInitialized: (state: AppState, action: PayloadAction<boolean>) => {
    state.isAppInitialized = action.payload;
  },
  setLoggedInUser: (state: AppState, action: PayloadAction<IUserProfile>) => {
    if (!isEqual(state.loggedInUser, action.payload)) {
      state.loggedInUser = action.payload;
    }
  },
  logoutUser: (state: AppState) => {
    //TODO refactor to root reducer level
    merge(state, initialAppState);
  },

  updateSnackBar: (state: AppState, action: PayloadAction<iSnackBar>) => {
    state.snackBarStates = action.payload;
  },

  resetSnackBar: (state: AppState) => {
    state.snackBarStates = snackBarInitialState;
  },
  setAppLoaderState: (state: AppState, action: PayloadAction<AppLoaderState>) => {
    state.appLoaderState = action.payload;
  },
  setAppConfig: (state: AppState, action: PayloadAction<AppConfig>) => {
    state.appConfig = action.payload;
  },
};

const appSlice = createSlice({
  name: 'appState',
  initialState: initialAppState,
  reducers: reducers,
});

export default appSlice.reducer;
export const AppActions = appSlice.actions;
